/* ==========================================================================
   House of Cardz – Theme JavaScript
   Navigation, Cart Drawer, Quick-Add, Varianten, Countdown
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(typeof data.description === 'string' ? data.description : window.HOC.strings.error);
        });
      }
      return res.json();
    });
  }

  function moneyFmt(cents) {
    return new Intl.NumberFormat(window.HOC.locale || 'de', {
      style: 'currency', currency: window.HOC.currency || 'EUR'
    }).format(cents / 100);
  }

  function cartEndpoint(action) {
    return window.HOC.routes.root_url.replace(/\/$/, '') + '/cart' + (action ? '/' + action : '') + '.js';
  }


  var inventory = window.HOCInventory;
  var inventoryLimits = Object.create(null);
  var stockCart = window.HOC.initialCart || { items: [] };
  var cartQueue = Promise.resolve();
  var updateProductInventory = function () {};

  function registerInventory(root) {
    qsa('[data-inventory-json]', root).forEach(function (node) {
      JSON.parse(node.textContent).forEach(function (variant) { inventoryLimits[String(variant.id)] = variant.limit; });
    });
    qsa('[data-stock-variant]', root).forEach(function (node) {
      inventoryLimits[node.getAttribute('data-stock-variant')] = node.getAttribute('data-stock-limit');
    });
  }

  function stockMessage(id) {
    return window.HOC.strings.stockLimit.replace('[quantity]', inventory.limit(inventoryLimits[String(id)]));
  }

  function inventoryProblem(problem) {
    return problem.type === 'stock' ? stockMessage(problem.id) :
      problem.type === 'changed' ? window.HOC.strings.cartChanged : window.HOC.strings.invalidQuantity;
  }

  function rowMaximum(row, root) {
    var id = row.getAttribute('data-stock-variant');
    var others = qsa('[data-cart-key]', root).reduce(function (total, other) {
      var input = qs('input[type="number"]', other);
      return other !== row && other.getAttribute('data-stock-variant') === id && input
        ? total + Math.max(0, Number(input.value) || 0) : total;
    }, 0);
    var range = gradingRange(gradingRowTitle(row));
    return Math.min(Math.max(0, inventory.limit(inventoryLimits[id]) - others), range ? range.max : Infinity);
  }

  function syncCartInputs(root) {
    if (!root) return;
    qsa('[data-cart-key]', root).forEach(function (row) {
      var input = qs('input[type="number"]', row);
      if (!input) return;
      var range = gradingRange(gradingRowTitle(row));
      var max = rowMaximum(row, root);
      input.min = range ? range.min : 0;
      input.step = '1';
      if (Number.isFinite(max)) input.max = max;
      else input.removeAttribute('max');
      qsa('[data-qty-change], [data-cartpage-qty]', row).forEach(function (button) {
        var direction = Number(button.getAttribute('data-qty-change') || button.getAttribute('data-cartpage-qty'));
        button.disabled = direction > 0 ? Number(input.value) >= max : Number(input.value) <= Number(input.min);
      });
    });
  }

  function syncInventoryControls() {
    qsa('.quick-add-btn').forEach(function (button) {
      if (button.hasAttribute('data-inventory-busy')) return;
      var id = button.getAttribute('data-variant-id');
      var exhausted = inventory.remaining(inventoryLimits, stockCart, id) < 1;
      button.disabled = exhausted;
      button.textContent = exhausted ? window.HOC.strings.stockInCart : window.HOC.strings.addToCart;
    });
    updateProductInventory(false);
    syncCartInputs(drawerWrapper);
    syncCartInputs(cartPageForm);
  }

  function rememberCart(cart) {
    stockCart = cart;
    syncInventoryControls();
    return cart;
  }

  function mutateCart(action) {
    var operation = cartQueue.then(function () {
      return fetchJSON(cartEndpoint(''), { cache: 'no-store' }).then(rememberCart).then(action);
    });
    cartQueue = operation.catch(function () {});
    return operation;
  }

  function checkStockAdd(items, cart) {
    var totals = Object.create(null);
    items.forEach(function (item) {
      var id = String(item.id), quantity = Number(item.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(window.HOC.strings.invalidQuantity);
      totals[id] = (totals[id] || 0) + quantity;
      if (totals[id] > inventory.remaining(inventoryLimits, cart, id)) throw new Error(stockMessage(id));
    });
  }

  function clampCartQuantity(input, root) {
    var row = input.closest('[data-cart-key]');
    var maximum = rowMaximum(row, root);
    var current = Number(input.value);
    if (input.value !== '' && current > maximum && Number.isFinite(maximum)) {
      input.value = maximum;
      var range = gradingRange(gradingRowTitle(row));
      var limitedByGrading = range && maximum === range.max;
      showCartError(limitedByGrading ? gradingMessage(gradingRowTitle(row)) : stockMessage(row.getAttribute('data-stock-variant')), root);
      input.setCustomValidity('');
    } else input.setCustomValidity('');
    syncCartInputs(root);
  }

  registerInventory(document);

  function gradingRange(title) {
    var text = String(title || '').trim();
    var match = text.match(/^(\d+)\s*(?:-|\u2013|\u2014|bis)\s*(\d+)\s*(?:Karten?|Booster)\s*:?$/i);
    if (match) return { min: Number(match[1]), max: Number(match[2]) };
    match = text.match(/^(?:ab\s*(\d+)|(\d+)\s*\+)\s*(?:Karten?|Booster)\s*:?$/i);
    return match ? { min: Number(match[1] || match[2]), max: Infinity } : null;
  }

  function gradingMessage(title) {
    return window.HOC.strings.gradingQuantity.replace('[staffel]', title);
  }

  function validGradingQuantity(title, quantity, allowRemoval) {
    var range = gradingRange(title);
    return Number.isSafeInteger(quantity) && (allowRemoval && quantity === 0 ||
      quantity >= (range ? range.min : 1) && quantity <= (range ? range.max : Infinity));
  }

  function gradingRowTitle(row) {
    return row && row.getAttribute('data-grading-variant') || '';
  }

  function setGradingInput(input, title) {
    var range = gradingRange(title);
    if (!input || !range) return;
    input.min = range.min;
    input.step = '1';
    if (Number.isFinite(range.max)) input.max = range.max;
    else input.removeAttribute('max');
    var row = input.closest('[data-grading-variant]');
    if (!row) return;
    qsa('[data-qty-change], [data-cartpage-qty]', row).forEach(function (button) {
      var direction = Number(button.getAttribute('data-qty-change') || button.getAttribute('data-cartpage-qty'));
      button.disabled = direction < 0 ? Number(input.value) <= range.min : Number(input.value) >= range.max;
    });
  }

  function showCartError(message, root) {
    var element = qs('[data-cart-error]', root || document);
    if (element) { element.textContent = message; element.hidden = !message; }
  }

  function validateCartInputs(root) {
    var valid = true;
    syncCartInputs(root);
    qsa('[data-cart-key]', root).forEach(function (row) {
      var title = gradingRowTitle(row);
      var input = qs('input[type="number"]', row);
      if (!input) return;
      var quantity = Number(input.value);
      var message = '';
      if (input.value === '' || !Number.isSafeInteger(quantity) || quantity < 0) message = window.HOC.strings.invalidQuantity;
      else if (gradingRange(title) && !validGradingQuantity(title, quantity, false)) message = gradingMessage(title);
      else if (quantity > rowMaximum(row, root)) message = stockMessage(row.getAttribute('data-stock-variant'));
      input.setCustomValidity(message);
      if (message && valid) {
        valid = false;
        showCartError(message, root);
        input.reportValidity();
      }
    });
    return valid;
  }

  function checkGradingCart(cart) {
    var invalid = cart.items.find(function (item) {
      return item.product_type === 'Grading Service' && gradingRange(item.variant_title) &&
        !validGradingQuantity(item.variant_title, item.quantity, false);
    });
    if (invalid) throw new Error(invalid.product_title + ': ' + gradingMessage(invalid.variant_title));
    return cart;
  }

  function containFocus(event, container) {
    if (event.key !== 'Tab') return;
    var controls = qsa('a[href], button, input, select, textarea, [tabindex="0"]', container).filter(function (el) {
      return !el.disabled && !el.closest('[hidden], [inert]') && el.getClientRects().length > 0;
    });
    if (!controls.length) return;
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  }

  /* ---------- Header: Mobile Menü ---------- */
  var header = qs('[data-header]');
  var menuToggle = qs('[data-menu-toggle]');
  if (menuToggle && header) {
    menuToggle.addEventListener('click', function () {
      var open = header.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    });
  }

  /* ---------- Header: Dropdowns ---------- */
  qsa('[data-dropdown-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var item = btn.closest('.has-dropdown');
      var isOpen = item.classList.contains('is-open');
      qsa('.has-dropdown.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var t = qs('[data-dropdown-toggle]', el);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function () {
    qsa('.has-dropdown.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      var t = qs('[data-dropdown-toggle]', el);
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- Header: Suche ---------- */
  var searchToggle = qs('[data-search-toggle]');
  var searchBox = qs('#HeaderSearch');
  if (searchToggle && searchBox) {
    searchToggle.addEventListener('click', function () {
      var hidden = searchBox.hasAttribute('hidden');
      if (hidden) {
        searchBox.removeAttribute('hidden');
        searchToggle.setAttribute('aria-expanded', 'true');
        var input = qs('input[type="search"]', searchBox);
        if (input) input.focus();
      } else {
        searchBox.setAttribute('hidden', '');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (searchBox && !searchBox.hidden) {
      searchBox.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.focus();
    }
    if (header && header.classList.contains('menu-open')) {
      header.classList.remove('menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Menü öffnen');
      menuToggle.focus();
    }
    qsa('.has-dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var toggle = qs('[data-dropdown-toggle]', item);
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    });
  });

  /* ---------- Cart Drawer ---------- */
  var drawerWrapper = qs('[data-cart-drawer]');
  var useDrawer = window.HOC && window.HOC.cartType === 'drawer' && drawerWrapper;

  var drawerReturnFocus = null;
  var drawerOverflow = '';
  function openDrawer() {
    if (!drawerWrapper) return;
    if (!drawerWrapper.classList.contains('is-open')) {
      drawerReturnFocus = document.activeElement;
      drawerOverflow = document.body.style.overflow;
    }
    drawerWrapper.inert = false;
    drawerWrapper.removeAttribute('inert');
    drawerWrapper.setAttribute('aria-hidden', 'false');
    drawerWrapper.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (!drawerWrapper.contains(document.activeElement)) {
      var close = qs('button[data-cart-drawer-close]', drawerWrapper);
      if (close) close.focus();
    }
  }
  function closeDrawer() {
    if (!drawerWrapper || !drawerWrapper.classList.contains('is-open')) return;
    drawerWrapper.classList.remove('is-open');
    document.body.style.overflow = drawerOverflow;
    if (drawerReturnFocus && drawerReturnFocus.isConnected) drawerReturnFocus.focus();
    drawerWrapper.inert = true;
    drawerWrapper.setAttribute('inert', '');
    drawerWrapper.setAttribute('aria-hidden', 'true');
  }
  function bindDrawerEvents() {
    registerInventory(drawerWrapper);
    qsa('[data-grading-variant]', drawerWrapper).forEach(function (row) {
      setGradingInput(qs('[data-qty-input]', row), gradingRowTitle(row));
    });
    qsa('[data-cart-drawer-close]', drawerWrapper).forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    qsa('[data-qty-change]', drawerWrapper).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var input = qs('[data-qty-input][data-line="' + line + '"]', drawerWrapper);
        var qty = Math.max(0, Number(input.value) + Number(btn.getAttribute('data-qty-change')));
        changeLine(line, qty);
      });
    });
    syncCartInputs(drawerWrapper);
    qsa('[data-qty-input]', drawerWrapper).forEach(function (input) {
      input.addEventListener('input', function () { clampCartQuantity(input, drawerWrapper); });
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        changeLine(line, Number(input.value));
      });
    });
    qsa('[data-remove-line]', drawerWrapper).forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.getAttribute('data-remove-line'), 10), 0);
      });
    });
    var discountForm = qs('[data-discount-form]', drawerWrapper);
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = qs('[data-discount-input]', discountForm);
        var code = (input.value || '').trim();
        if (!code) { return; }
        input.value = '';
        var codes = appliedDiscountCodes.slice();
        if (!codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          codes.push(code);
        }
        applyDiscountCodes(codes, code);
      });
    }
    var chipWrap = qs('[data-discount-chips]', drawerWrapper);
    if (chipWrap) {
      chipWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove-code]');
        if (!btn) { return; }
        var code = btn.getAttribute('data-remove-code');
        applyDiscountCodes(appliedDiscountCodes.filter(function (c) { return c !== code; }), null);
      });
    }
  }

  function refreshDrawer(open) {
    var sectionUrl = new URL(window.location.href);
    sectionUrl.searchParams.set('sections', 'cart-drawer');
    return fetchJSON(sectionUrl.toString())
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) throw new Error(window.HOC.strings.error);
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = qs('[data-cart-drawer]', tmp);
        if (fresh && drawerWrapper) {
          var wasOpen = drawerWrapper.classList.contains('is-open');
          var active = drawerWrapper.contains(document.activeElement) ? document.activeElement : null;
          var activeLine = active && active.getAttribute('data-line');
          var activeQty = active && active.getAttribute('data-qty-change');
          drawerWrapper.innerHTML = fresh.innerHTML;
          bindDrawerEvents();
          if (wasOpen || open) openDrawer();
          if (activeLine) {
            var selector = activeQty !== null ? '[data-qty-change="' + activeQty + '"]' : '[data-qty-input]';
            var replacement = qs(selector + '[data-line="' + activeLine + '"]', drawerWrapper);
            if (replacement) replacement.focus();
          }
        }
        return updateCartCount();
      });
  }

  var appliedDiscountCodes = [];
  var pendingDiscountMsg = null;

  function renderCartExtras(cart) {
    if (!drawerWrapper) { return; }

    /* Rabatt-Chips (aus der AJAX-Antwort – Liquid kennt manuelle Codes serverseitig nicht) */
    var chips = qs('[data-discount-chips]', drawerWrapper);
    var codes = (cart.discount_codes || []).filter(function (c) { return c && c.code; });
    appliedDiscountCodes = codes.map(function (c) { return c.code; });
    if (chips) {
      chips.innerHTML = '';
      codes.forEach(function (c) {
        var chip = document.createElement('span');
        chip.className = 'cart-discount__chip';
        var label = document.createElement('span');
        label.textContent = c.code + (c.applicable ? '' : ' · ' + window.HOC.strings.discountPending);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-remove-code', c.code);
        btn.setAttribute('aria-label', 'Code ' + c.code + ' entfernen');
        btn.textContent = '\u00D7';
        chip.appendChild(label);
        chip.appendChild(btn);
        chips.appendChild(chip);
      });
    }

    /* Rabattzeile + Zwischensumme */
    var discountRow = qs('[data-discount-row]', drawerWrapper);
    var discountAmount = qs('[data-discount-amount]', drawerWrapper);
    var subtotalEl = qs('[data-cart-subtotal]', drawerWrapper);
    var totalDiscount = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      totalDiscount += d.total_allocated_amount || 0;
    });
    if (discountRow && discountAmount) {
      discountRow.hidden = totalDiscount <= 0;
      if (totalDiscount > 0) { discountAmount.textContent = '\u2212' + moneyFmt(totalDiscount); }
    }
    if (subtotalEl) { subtotalEl.textContent = moneyFmt(cart.total_price); }

    /* Nachricht nach Drawer-Neuaufbau wiederherstellen */
    var msgEl = qs('[data-discount-msg]', drawerWrapper);
    if (msgEl && pendingDiscountMsg) {
      msgEl.textContent = pendingDiscountMsg.text;
      msgEl.className = 'cart-discount__msg ' + pendingDiscountMsg.type;
      msgEl.hidden = false;
    }

    /* Versand-Fortschrittsbalken mit rabattiertem Warenwert aktualisieren */
    var bar = qs('[data-shipbar]', drawerWrapper);
    if (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold') || '0', 10);
      if (threshold > 0) {
        var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
        var fill = qs('[data-shipbar-fill]', bar);
        var truck = qs('[data-shipbar-truck]', bar);
        var text = qs('[data-shipbar-text]', bar);
        if (fill) { fill.style.width = pct + '%'; }
        if (truck) { truck.style.left = 'clamp(15px, ' + pct + '%, calc(100% - 15px))'; }
        bar.classList.toggle('is-reached', pct >= 100);
        if (text) {
          text.textContent = pct >= 100
            ? bar.getAttribute('data-text-reached')
            : (bar.getAttribute('data-text-progress') || '').replace('[betrag]', moneyFmt(threshold - cart.total_price));
        }
      }
    }
  }

  function updateCartCount() {
    return fetchJSON(cartEndpoint('')).then(function (cart) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      var cartLink = qs('[data-cart-toggle]');
      if (cartLink) cartLink.setAttribute('aria-label', 'Warenkorb (' + cart.item_count + ' Artikel)');
      renderCartExtras(cart);
      return rememberCart(cart);
    });
  }

  function setDiscountMsg(text, type) {
    pendingDiscountMsg = text ? { text: text, type: type } : null;
    var msgEl = drawerWrapper ? qs('[data-discount-msg]', drawerWrapper) : null;
    if (!msgEl) { return; }
    msgEl.hidden = !text;
    msgEl.textContent = text || '';
    msgEl.className = 'cart-discount__msg' + (type ? ' ' + type : '');
  }

  function applyDiscountCodes(codes, newCode) {
    if (drawerWrapper) { drawerWrapper.classList.add('is-loading'); }
    setDiscountMsg('');
    return fetchJSON(cartEndpoint('update'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    })
      .then(function (cart) {
        if (!newCode) {
          setDiscountMsg('Code entfernt.', 'is-success');
          return refreshDrawer(false);
        }
        var known = cart.discount_codes;
        if (typeof known === 'undefined') {
          setDiscountMsg(window.HOC.strings.discountUnverified, 'is-error');
          return refreshDrawer(false);
        }
        var entry = (known || []).find(function (c) {
          return c.code.toLowerCase() === newCode.toLowerCase();
        });
        if (entry && entry.applicable) {
          /* Cookie zusätzlich setzen, damit der Code den Checkout sicher erreicht */
          setDiscountMsg('Code „' + newCode.toUpperCase() + '" angewendet.', 'is-success');
          return refreshDrawer(false);
        }
        /* Ungültig: Code wieder entfernen */
        var remaining = codes.filter(function (c) { return c.toLowerCase() !== newCode.toLowerCase(); });
        return fetchJSON(cartEndpoint('update'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') })
        }).then(function () {
          setDiscountMsg('Dieser Code ist ungültig oder auf deinen Warenkorb nicht anwendbar.', 'is-error');
          return refreshDrawer(false);
        });
      })
      .catch(function () {
        setDiscountMsg('Der Code konnte nicht geprüft werden – bitte versuche es erneut.', 'is-error');
      })
      .finally(function () {
        if (drawerWrapper) { drawerWrapper.classList.remove('is-loading'); }
      });
  }

  function changeLine(line, quantity) {
    if (drawerWrapper.classList.contains('is-loading')) return;
    var row = qs('.cart-drawer__item[data-line="' + line + '"]', drawerWrapper);
    if (!row) return;
    var title = gradingRowTitle(row);
    if (!validGradingQuantity(title, quantity, true)) {
      showCartError(gradingRange(title) ? gradingMessage(title) : window.HOC.strings.invalidQuantity, drawerWrapper);
      var input = qs('[data-qty-input]', row);
      if (input) input.value = row.getAttribute('data-current-quantity');
      return;
    }
    drawerWrapper.classList.add('is-loading');
    showCartError('', drawerWrapper);
    mutateCart(function (cart) {
      var updates = {};
      updates[row.getAttribute('data-cart-key')] = quantity;
      var problem = inventory.problem(inventoryLimits, cart, updates);
      if (problem) throw new Error(inventoryProblem(problem));
      return fetchJSON(cartEndpoint('change'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: row.getAttribute('data-cart-key'), quantity: quantity })
      }).then(rememberCart);
    }).then(function () { return refreshDrawer(false); })
      .catch(function (error) {
        return refreshDrawer(false).catch(function () {}).then(function () { showCartError(error.message, drawerWrapper); });
      }).finally(function () {
        drawerWrapper.classList.remove('is-loading');
        syncInventoryControls();
      });
  }

  function addToCart(items) {
    return mutateCart(function (cart) {
      checkStockAdd(items, cart);
      return fetchJSON(cartEndpoint('add'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (result) {
        return updateCartCount().then(function () { return result; });
      });
    });
  }

  if (drawerWrapper) {
    bindDrawerEvents();
    updateCartCount().catch(function () {});
    var cartToggle = qs('[data-cart-toggle]');
    if (cartToggle && useDrawer) {
      cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (!drawerWrapper.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeDrawer();
      else containFocus(e, drawerWrapper);
    });
  }

  /* ---------- Quick-Add auf Produktkarten ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var original = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('data-inventory-busy', 'true');
    btn.textContent = window.HOC.strings.adding;
    addToCart([{ id: variantId, quantity: 1 }])
      .then(function () {
        btn.textContent = window.HOC.strings.added;
        if (useDrawer) {
          return refreshDrawer(true);
        }
        return updateCartCount();
      })
      .catch(function (error) {
        return updateCartCount().catch(function () {}).then(function () {
          btn.textContent = error.message;
          showCartError(error.message, drawerWrapper);
        });
      })
      .finally(function () {
        setTimeout(function () {
          btn.removeAttribute('data-inventory-busy');
          syncInventoryControls();
        }, 1600);
      });
  });

  /* ---------- Produktseite: Varianten ---------- */
  var productSection = qs('[data-product-section]');
  if (productSection) {
    var variantsJson = qs('[data-variants-json]', productSection);
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var gradingProduct = productSection.hasAttribute('data-grading-product');
    var productQty = qs('input[name="quantity"]', productSection);
    var optionSelects = qsa('[data-option-select]', productSection);
    var variantInput = qs('[data-variant-id]', productSection);
    var addBtn = qs('[data-add-to-cart]', productSection);
    var priceWrapper = qs('[data-price-wrapper]', productSection);
    var skuEl = qs('[data-sku]', productSection);
    var mainImage = qs('#ProductMainImage', productSection);

    function formatMoney(cents) { return moneyFmt(cents); }

    function currentVariant() {
      var selected = optionSelects.map(function (s) { return s.value; });
      return variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
    }


    function updateGradingQuantity(reset, clampStock) {
      if (!productQty) return true;
      var variant = currentVariant();
      if (!variant) {
        productQty.disabled = true;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.HOC.strings.unavailable; }
        return false;
      }
      var range = gradingProduct ? gradingRange(variant.title) : null;
      var minimum = range ? range.min : 1;
      var remaining = variant ? inventory.remaining(inventoryLimits, stockCart, variant.id) : 0;
      var maximum = Math.min(remaining, range ? range.max : Infinity);
      var quantity = Number(productQty.value);
      var clamped = false;
      if (reset && (!Number.isSafeInteger(quantity) || quantity < minimum || quantity > maximum)) {
        productQty.value = maximum >= minimum ? Math.min(Math.max(minimum, quantity || minimum), maximum) : minimum;
        quantity = Number(productQty.value);
      }
      if (clampStock && quantity > remaining && remaining >= minimum) {
        productQty.value = remaining;
        quantity = remaining;
        clamped = true;
      }
      productQty.min = minimum;
      productQty.step = '1';
      productQty.disabled = maximum < minimum || !variant || !variant.available;
      if (Number.isFinite(maximum)) productQty.max = maximum;
      else productQty.removeAttribute('max');
      var valid = productQty.value !== '' && Number.isSafeInteger(quantity) && quantity >= minimum && quantity <= maximum;
      var message = valid ? '' : quantity > remaining ? stockMessage(variant.id) :
        range ? gradingMessage(variant.title) : window.HOC.strings.invalidQuantity;
      productQty.setCustomValidity(message);
      var error = qs('[data-product-error]', productSection);
      if (error && (message || clamped || reset || clampStock)) {
        error.textContent = clamped ? stockMessage(variant.id) : message;
        error.hidden = !error.textContent || maximum < minimum;
      }
      var hint = qs('[data-product-stock]', productSection);
      if (hint) {
        hint.hidden = !Number.isFinite(remaining) || !variant || !variant.available;
        hint.textContent = remaining === 0 ? window.HOC.strings.stockInCartNote : window.HOC.strings.stockRemaining.replace('[quantity]', remaining);
      }
      qsa('[data-pdp-qty]', productSection).forEach(function (button) {
        button.disabled = productQty.disabled || (Number(button.getAttribute('data-pdp-qty')) < 0 ? quantity <= minimum : quantity >= maximum);
      });
      if (addBtn && !addBtn.hasAttribute('data-inventory-busy')) {
        addBtn.disabled = !variant || !variant.available || maximum < minimum;
        addBtn.textContent = !variant ? window.HOC.strings.unavailable : !variant.available ? window.HOC.strings.soldOut :
          remaining === 0 ? window.HOC.strings.stockInCart : window.HOC.strings.addToCart;
      }
      return valid;
    }

    function onVariantChange() {
      var variant = currentVariant();
      var stockNote = qs('[data-stock-note]', productSection);
      var restockBox = qs('[data-restock]', productSection);
      var skuWrapper = qs('[data-sku-wrapper]', productSection);
      if (stockNote) stockNote.hidden = !variant || !variant.available;
      if (restockBox) restockBox.hidden = !variant || variant.available;
      if (skuWrapper) skuWrapper.hidden = !variant || !variant.sku;
      if (priceWrapper) priceWrapper.hidden = !variant;
      if (!variant) {
        if (variantInput) { variantInput.value = ''; variantInput.disabled = true; }
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.HOC.strings.unavailable; }
        return;
      }
      if (variantInput) { variantInput.disabled = false; variantInput.value = variant.id; }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? window.HOC.strings.addToCart : window.HOC.strings.soldOut;
      }
      if (priceWrapper) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var salePct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          var badgeText = (window.HOC.showSalePercent && salePct > 0) ? '\u2212' + salePct + '\u00A0%' : 'Sale';
          html = '<div class="price price--on-sale">' +
            '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
            '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
            '<span class="badge badge--sale">' + badgeText + '</span></div>';
        } else {
          html = '<div class="price"><span class="price__regular">' + formatMoney(variant.price) + '</span></div>';
        }
        priceWrapper.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = variant.sku || '';
      var restockBox = qs('[data-restock]', productSection);
      if (restockBox) {
        restockBox.hidden = variant.available;
        var restockVariant = qs('[data-restock-variant]', restockBox);
        if (restockVariant) { restockVariant.value = variant.title; }
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
        mainImage.setAttribute('data-image-id', variant.featured_image.id);
        var zoomLink = qs('[data-zoom-open]', productSection);
        if (zoomLink) zoomLink.href = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || qs('.product-main__title', productSection).textContent;
        mainImage.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      updateGradingQuantity(true);
    }

    optionSelects.forEach(function (s) { s.addEventListener('change', onVariantChange); });

    /* Galerie-Thumbnails */
    qsa('[data-thumb]', productSection).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        qsa('[data-thumb]', productSection).forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-pressed', 'false'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (mainImage) {
          mainImage.src = thumb.getAttribute('data-full');
          mainImage.setAttribute('data-image-id', thumb.getAttribute('data-image-id'));
          mainImage.alt = thumb.getAttribute('data-alt') || '';
          mainImage.removeAttribute('srcset');
        }
      });
    });

    /* Mengen-Buttons */
    qsa('[data-pdp-qty]', productSection).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = qs('input[name="quantity"]', productSection);
        var val = Math.max(1, parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-pdp-qty'), 10));
        input.value = val;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    if (productQty) {
      productQty.addEventListener('input', function () { updateGradingQuantity(false, true); });
      productQty.addEventListener('change', function () { updateGradingQuantity(false, true); });
    }
    updateProductInventory = updateGradingQuantity;
    updateGradingQuantity(true);

    /* Formular abschicken: AJAX mit FormData (inkl. Bestell-Eigenschaften).
       Bei angehängter Datei: nativer Submit, da die AJAX-API keine Dateien unterstützt. */
    var productForm = qs('.product-form', productSection);
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled || !variantInput.value) return;
        if (!updateGradingQuantity(false)) { productQty.reportValidity(); return; }
        var formId = productForm.getAttribute('id');
        var fileInputs = qsa('input[type="file"]', productForm)
          .concat(formId ? qsa('input[type="file"][form="' + formId + '"]') : []);
        var hasFile = fileInputs.some(function (fi) { return fi.files && fi.files.length > 0; });
        var productError = qs('[data-product-error]', productSection);
        if (productError) productError.hidden = true;
        var fd = new FormData(productForm);
        addBtn.disabled = true;
        addBtn.setAttribute('data-inventory-busy', 'true');
        addBtn.textContent = window.HOC.strings.adding;
        mutateCart(function (cart) {
          checkStockAdd([{ id: fd.get('id'), quantity: Number(fd.get('quantity') || 1) }], cart);
          if (hasFile) { HTMLFormElement.prototype.submit.call(productForm); return null; }
          return fetchJSON(cartEndpoint('add'), { method: 'POST', body: fd })
            .then(function (result) { return updateCartCount().then(function () { return result; }); });
        }).then(function () {
          if (hasFile) return;
          addBtn.textContent = window.HOC.strings.added;
          if (useDrawer) return refreshDrawer(true);
          window.location.assign(window.HOC.routes.cart_url);
        }).catch(function (error) {
          return updateCartCount().catch(function () {}).then(function () {
            if (productError) { productError.textContent = error.message; productError.hidden = false; }
          });
        }).finally(function () {
          addBtn.removeAttribute('data-inventory-busy');
          syncInventoryControls();
        });
      });
    }
  }

  qsa('[data-product-recommendations]').forEach(function (section) {
    fetch(section.getAttribute('data-url')).then(function (response) {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.text();
    }).then(function (html) {
      var fragment = document.createElement('div');
      fragment.innerHTML = html;
      var content = qs('[data-product-recommendations]', fragment);
      if (content && qs('.product-card__link', content)) {
        section.innerHTML = content.innerHTML;
        registerInventory(section);
        syncInventoryControls();
        section.hidden = false;
      }
    }).catch(function () { section.hidden = true; });
  });


  var cartPageForm = qs('.cart-page__form');
  if (cartPageForm) {
    syncCartInputs(cartPageForm);
    qsa('[data-cartpage-qty]', cartPageForm).forEach(function (button) {
      button.addEventListener('click', function () {
        var input = qs('input', button.parentElement);
        var row = input.closest('[data-cart-key]');
        var title = gradingRowTitle(row);
        var quantity = Math.max(0, Number(input.value) + Number(button.getAttribute('data-cartpage-qty')));
        if (gradingRange(title) && !validGradingQuantity(title, quantity, false)) {
          showCartError(gradingMessage(title), cartPageForm); return;
        }
        input.value = Math.min(quantity, rowMaximum(row, cartPageForm));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    cartPageForm.addEventListener('input', function (event) {
      if (event.target.name === 'updates[]') clampCartQuantity(event.target, cartPageForm);
    });
    cartPageForm.addEventListener('change', function (event) {
      if (event.target.name !== 'updates[]') return;
      clampCartQuantity(event.target, cartPageForm);
      validateCartInputs(cartPageForm);
    });
    cartPageForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (cartPageForm.getAttribute('aria-busy') === 'true' || !validateCartInputs(cartPageForm)) return;
      var checkout = event.submitter && event.submitter.name === 'checkout';
      var updates = {};
      qsa('[data-cart-key]', cartPageForm).forEach(function (row) {
        updates[row.getAttribute('data-cart-key')] = Number(qs('input[name="updates[]"]', row).value);
      });
      var note = qs('[name="note"]', cartPageForm);
      cartPageForm.setAttribute('aria-busy', 'true');
      qsa('button[type="submit"]', cartPageForm).forEach(function (button) { button.disabled = true; });
      mutateCart(function (cart) {
        var problem = inventory.problem(inventoryLimits, cart, updates);
        if (problem) throw new Error(inventoryProblem(problem));
        var current = cart;
        var changes = cart.items.filter(function (item) {
          return Object.prototype.hasOwnProperty.call(updates, item.key) && updates[item.key] !== item.quantity;
        }).sort(function (a, b) {
          return (updates[a.key] - a.quantity) - (updates[b.key] - b.quantity);
        });
        return changes.reduce(function (chain, original) {
          return chain.then(function () {
            var item = inventory.findLine(current, original);
            if (!item) throw new Error(window.HOC.strings.cartChanged);
            return fetchJSON(cartEndpoint('change'), {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: updates[original.key] })
            }).then(function (cart) { current = rememberCart(cart); });
          });
        }, Promise.resolve()).then(function () {
          if (!note) return current;
          return fetchJSON(cartEndpoint('update'), {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value })
          }).then(rememberCart);
        });
      }).then(checkGradingCart).then(function () {
        if (checkout) window.location.assign(window.HOC.routes.cart_url + '/checkout');
        else window.location.reload();
      }).catch(function (error) {
        showCartError(error.message, cartPageForm);
        cartPageForm.removeAttribute('aria-busy');
        qsa('button[type="submit"]', cartPageForm).forEach(function (button) { button.disabled = false; });
        updateCartCount().catch(function () {});
      });
    });
  }
  syncInventoryControls();

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cart-checkout]');
    if (!link) return;
    event.preventDefault();
    if (drawerWrapper.classList.contains('is-loading') || link.getAttribute('aria-busy') === 'true') return;
    if (!validateCartInputs(drawerWrapper)) return;
    link.setAttribute('aria-busy', 'true');
    fetchJSON(cartEndpoint('')).then(checkGradingCart).then(function () {
      window.location.assign(link.href);
    }).catch(function (error) {
      showCartError(error.message, drawerWrapper);
      link.removeAttribute('aria-busy');
    });
  });

  /* ---------- Kollektion: Sortierung ---------- */
  var sortSelect = qs('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Countdown ---------- */
  qsa('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown'));
    if (isNaN(target.getTime())) return;
    var days = qs('[data-cd-days]', el);
    var hours = qs('[data-cd-hours]', el);
    var mins = qs('[data-cd-mins]', el);
    var secs = qs('[data-cd-secs]', el);
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        days.textContent = hours.textContent = mins.textContent = secs.textContent = '00';
        clearInterval(timer);
        return;
      }
      days.textContent = pad(Math.floor(diff / 86400000));
      hours.textContent = pad(Math.floor(diff / 3600000) % 24);
      mins.textContent = pad(Math.floor(diff / 60000) % 60);
      secs.textContent = pad(Math.floor(diff / 1000) % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Konto: Login/Recover-Umschalter ---------- */
  var loginBox = qs('[data-login-box]');
  var recoverBox = qs('[data-recover-box]');
  if (loginBox && recoverBox) {
    var showRecover = qs('[data-show-recover]');
    var showLogin = qs('[data-show-login]');
    if (showRecover) showRecover.addEventListener('click', function () {
      loginBox.hidden = true; recoverBox.hidden = false;
    });
    if (showLogin) showLogin.addEventListener('click', function () {
      recoverBox.hidden = true; loginBox.hidden = false;
    });
    if (window.location.hash === '#recover') {
      loginBox.hidden = true; recoverBox.hidden = false;
    }
  }

  /* ---------- Konto: Adressen ---------- */
  qsa('[data-address-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-address-toggle'));
      if (target) target.hidden = !target.hidden;
    });
  });
  qsa('select[data-default]').forEach(function (select) {
    var val = select.getAttribute('data-default');
    if (val) select.value = val;
  });

  /* ==========================================================================
     Karten-Listen-Baustein (Upload, CSV-Vorlage, manuelle Eingabe im Pop-up)
     ========================================================================== */
  qsa('[data-card-sub]').forEach(function (root) {
    var formId = root.getAttribute('data-form-id');
    var columns = (root.getAttribute('data-columns') || '').split(';').map(function (c) { return c.trim(); }).filter(Boolean);
    var maxBytes = parseFloat(root.getAttribute('data-max-mb') || '2') * 1024 * 1024;
    var syncQty = root.getAttribute('data-sync-qty') === 'true';
    var propName = root.getAttribute('data-property-name') || 'Kartenliste';

    var section = root.closest('[data-product-section]') || document;
    var qtyInput = qs('.product-form input[name="quantity"]', section);
    var variantsJsonEl = qs('[data-variants-json]', section);
    var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
    var variantIdInput = qs('[data-variant-id]', section);

    var fileInput = qs('[data-cs-file-input]', root);
    var dropzone = qs('[data-cs-dropzone]', root);
    var fileInfo = qs('[data-cs-file-info]', root);
    var fileName = qs('[data-cs-file-name]', root);
    var errorEl = qs('[data-cs-error]', root);
    var listEl = qs('[data-cs-list]', root);
    var rowsEl = qs('[data-cs-rows]', root);
    var countEl = qs('[data-cs-count]', root);
    var modal = qs('[data-cs-modal]', root);
    var modalFields = qs('[data-cs-modal-fields]', root);
    var modalTitle = qs('[data-cs-modal-title]', root);

    var entries = [];
    var editIndex = -1;
    var modalTrigger = null;
    var previousBodyOverflow = '';

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€';
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }
    function currentUnitPrice() {
      if (!variants.length) return 0;
      var id = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
      var v = variants.find(function (x) { return x.id === id; }) || variants[0];
      return v ? v.price : 0;
    }

    /* ---------- CSV-Vorlage ---------- */
    var templateBtn = qs('[data-cs-template]', root);
    if (templateBtn) {
      templateBtn.addEventListener('click', function () {
        var example = columns.map(function (c) {
          var l = c.toLowerCase();
          if (l.indexOf('jahr') > -1) return '1999';
          if (l.indexOf('set') > -1) return 'Base Set';
          if (l.indexOf('name') > -1) return 'Glurak';
          if (l.indexOf('nummer') > -1) return '4/102';
          if (l.indexOf('sprache') > -1) return 'DE';
          if (l.indexOf('wert') > -1) return '500';
          return '';
        });
        var csv = '\ufeff' + columns.join(';') + '\n' + example.join(';') + '\n';
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'kartenliste-vorlage.csv';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
      });
    }

    /* ---------- Datei-Upload / Dropzone ---------- */
    function validateFile(file) {
      if (file.size > maxBytes) {
        showError('Die Datei ist zu groß (max. ' + (maxBytes / 1024 / 1024) + ' MB).');
        return false;
      }
      var accept = (fileInput.getAttribute('accept') || '').split(',').map(function (a) { return a.trim().toLowerCase(); }).filter(Boolean);
      if (accept.length) {
        var name = file.name.toLowerCase();
        var ok = accept.some(function (ext) { return name.endsWith(ext); });
        if (!ok) {
          showError('Dateityp nicht erlaubt. Erlaubt: ' + accept.join(', '));
          return false;
        }
      }
      showError('');
      return true;
    }
    function onFileSelected() {
      var file = fileInput.files && fileInput.files[0];
      if (!file) { fileInfo.hidden = true; update(); return; }
      if (!validateFile(file)) {
        fileInput.value = '';
        fileInfo.hidden = true;
        update();
        return;
      }
      fileName.textContent = file.name + ' (' + (file.size / 1024).toFixed(0) + ' KB)';
      fileInfo.hidden = false;
      update();
    }
    if (fileInput) {
      fileInput.addEventListener('change', onFileSelected);
    }
    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('is-dragover'); });
      });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) {
          try {
            var dt = new DataTransfer();
            dt.items.add(e.dataTransfer.files[0]);
            fileInput.files = dt.files;
          } catch (err) { /* ältere Browser */ }
          onFileSelected();
        }
      });
    }
    var fileRemove = qs('[data-cs-file-remove]', root);
    if (fileRemove) {
      fileRemove.addEventListener('click', function () {
        fileInput.value = '';
        fileInfo.hidden = true;
        showError('');
        update();
      });
    }

    /* ---------- Modal: Details manuell hinzufügen ---------- */
    function openModal(index) {
      modalTrigger = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      editIndex = typeof index === 'number' ? index : -1;
      modalTitle.textContent = editIndex >= 0 ? 'Kartendetails bearbeiten' : 'Kartendetails hinzufügen';
      modalFields.innerHTML = '';
      columns.forEach(function (col, i) {
        var wrap = document.createElement('div');
        wrap.className = 'form-field';
        var label = document.createElement('label');
        label.textContent = col;
        var input = document.createElement('input');
        input.type = 'text';
        input.id = formId + '-card-field-' + i;
        label.htmlFor = input.id;
        input.setAttribute('data-cs-field', i);
        if (editIndex >= 0 && entries[editIndex]) input.value = entries[editIndex][col] || '';
        wrap.appendChild(label);
        wrap.appendChild(input);
        modalFields.appendChild(wrap);
      });
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = qs('input', modalFields);
      if (first) first.focus();
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = previousBodyOverflow;
      if (modalTrigger && modalTrigger.isConnected) modalTrigger.focus();
    }
    qsa('[data-cs-modal-close]', root).forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key !== 'Tab') return;
      var focusable = qsa('button:not([disabled]), input:not([disabled])', modal);
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var addBtnCs = qs('[data-cs-add]', root);
    if (addBtnCs) addBtnCs.addEventListener('click', function () { openModal(-1); });

    var saveBtn = qs('[data-cs-modal-save]', root);
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var entry = {};
        var hasValue = false;
        qsa('[data-cs-field]', modalFields).forEach(function (input, i) {
          var val = input.value.trim();
          entry[columns[i]] = val;
          if (val) hasValue = true;
        });
        if (!hasValue) {
          var first = qs('input', modalFields);
          if (first) first.focus();
          return;
        }
        if (editIndex >= 0) { entries[editIndex] = entry; }
        else { entries.push(entry); }
        closeModal();
        update();
      });
    }
    modalFields.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); saveBtn.click(); }
    });

    /* ---------- Liste mit 3-Punkte-Menü ---------- */
    function closeMenus() {
      qsa('.card-sub__row-menu.is-open', root).forEach(function (m) { m.classList.remove('is-open'); });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.card-sub__row-menu-btn')) closeMenus();
    });

    function renderRows() {
      rowsEl.innerHTML = '';
      entries.forEach(function (entry, i) {
        var row = document.createElement('div');
        row.className = 'card-sub__row';

        var num = document.createElement('span');
        num.className = 'card-sub__row-num';
        num.textContent = i + 1;

        var text = document.createElement('div');
        text.className = 'card-sub__row-text';
        var nameCol = columns.find(function (c) { return c.toLowerCase().indexOf('name') > -1; }) || columns[0];
        var strong = document.createElement('strong');
        strong.textContent = entry[nameCol] || 'Karte ' + (i + 1);
        var rest = document.createElement('span');
        rest.textContent = columns
          .filter(function (c) { return c !== nameCol && entry[c]; })
          .map(function (c) { return entry[c]; })
          .join(' · ');
        text.appendChild(strong);
        if (rest.textContent) text.appendChild(rest);

        var menuBtn = document.createElement('button');
        menuBtn.type = 'button';
        menuBtn.className = 'card-sub__row-menu-btn';
        menuBtn.setAttribute('aria-label', 'Aktionen für Karte ' + (i + 1));
        menuBtn.textContent = '\u22EF';

        var menu = document.createElement('div');
        menu.className = 'card-sub__row-menu';
        [['Bearbeiten', function () { openModal(i); }],
         ['Kopieren', function () { entries.splice(i + 1, 0, JSON.parse(JSON.stringify(entries[i]))); update(); }],
         ['Löschen', function () { entries.splice(i, 1); update(); }, true]
        ].forEach(function (def) {
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = def[0];
          if (def[2]) b.className = 'is-danger';
          b.addEventListener('click', function (e) { e.stopPropagation(); closeMenus(); def[1](); });
          menu.appendChild(b);
        });

        menuBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var wasOpen = menu.classList.contains('is-open');
          closeMenus();
          if (!wasOpen) menu.classList.add('is-open');
        });

        row.appendChild(num);
        row.appendChild(text);
        row.appendChild(menuBtn);
        row.appendChild(menu);
        rowsEl.appendChild(row);
      });
      listEl.hidden = entries.length === 0;
      countEl.textContent = entries.length;
    }

    /* ---------- Bestell-Eigenschaften (Line Item Properties) ---------- */
    function syncProperties() {
      qsa('[data-cs-prop]', root).forEach(function (el) { el.remove(); });
      function addProp(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = value;
        input.setAttribute('data-cs-prop', '');
        if (formId) input.setAttribute('form', formId);
        root.appendChild(input);
      }
      entries.forEach(function (entry, i) {
        var parts = columns
          .filter(function (c) { return entry[c]; })
          .map(function (c) { return c + ': ' + entry[c]; });
        addProp('Karte ' + (i + 1), parts.join(' | '));
      });
      if (entries.length > 0) {
        addProp('Kartenanzahl', String(entries.length));
        addProp('Liste ausgefüllt', 'Ja (im Browser)');
      }
    }

    /* ---------- Menge & Preis-Zusammenfassung ---------- */
    var summary = qs('[data-cs-summary]', root);
    function updateSummary() {
      if (!summary) return;
      var fileProvided = fileInput && fileInput.files && fileInput.files.length > 0;
      var count = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10) || 1) : 1;
      var show = entries.length > 0 || fileProvided;
      summary.hidden = !show;
      if (!show) return;

      var unit = currentUnitPrice();
      var total = unit * count;

      qs('[data-cs-sum-count]', summary).textContent = count;
      qs('[data-cs-sum-unit]', summary).textContent = formatMoney(unit);
      qs('[data-cs-sum-total]', summary).textContent = formatMoney(total);
    }

    function update() {
      renderRows();
      syncProperties();
      if (syncQty && qtyInput && entries.length > 0) {
        qtyInput.value = entries.length;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      updateSummary();
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateSummary);
      qtyInput.addEventListener('change', updateSummary);
    }
    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-select]')) return;
      if (syncQty && qtyInput && entries.length > 0) {
        qtyInput.value = entries.length;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      updateSummary();
    });
    update();
  });


  /* ---------- Ankündigungsleiste: Rotation mehrerer Ankündigungen ---------- */
  qsa('[data-announcement-bar]').forEach(function (bar) {
    var slides = qsa('.announcement-bar__slide', bar);
    if (slides.length < 2) { return; }
    var interval = Math.max(2, parseFloat(bar.getAttribute('data-rotate-seconds') || '6')) * 1000;
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
    }
    function start() {
      stop();
      timer = setInterval(function () { show(index + 1); }, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    start();

    /* Theme-Editor: ausgewählten Block anzeigen, Rotation solange pausieren */
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest ? e.target.closest('.announcement-bar__slide') : null;
      if (!slide || !bar.contains(slide)) { return; }
      stop();
      show(slides.indexOf(slide));
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var slide = e.target.closest ? e.target.closest('.announcement-bar__slide') : null;
      if (!slide || !bar.contains(slide)) { return; }
      start();
    });
  });


  /* ==========================================================================
     Booster-Popup: Pack öffnen, Karte ziehen, Rabatt gewinnen
     ========================================================================== */
  qsa('[data-booster]').forEach(function (root) {
    var configEl = qs('[data-booster-config]', root);
    var cards = [];
    try { cards = JSON.parse(configEl.textContent); } catch (e) { return; }
    cards = cards.filter(function (c) { return c && c.weight > 0; });
    if (!cards.length) { return; }

    var delayMs = Math.max(0, parseFloat(root.getAttribute('data-delay') || '5')) * 1000;
    var reshowMs = Math.max(1, parseFloat(root.getAttribute('data-reshow-days') || '14')) * 86400000;
    var storageKey = 'hoc_booster_last';
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var opened = false;

    function storageGet() {
      try { return parseInt(localStorage.getItem(storageKey) || '0', 10); } catch (e) { return 0; }
    }
    function storageSet() {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) { /* Privatmodus */ }
    }

    var popupReturnFocus = null;
    var popupOverflow = '';
    function openPopup() {
      if (drawerWrapper && drawerWrapper.classList.contains('is-open')) return;
      if (!root.classList.contains('is-open')) {
        popupReturnFocus = document.activeElement;
        popupOverflow = document.body.style.overflow;
      }
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      qs('button[data-booster-close]', root).focus();
    }
    function closePopup() {
      root.classList.remove('is-open');
      document.body.style.overflow = popupOverflow;
      if (popupReturnFocus && popupReturnFocus.isConnected) popupReturnFocus.focus();
      if (!designMode) { storageSet(); }
    }
    qsa('[data-booster-close]', root).forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) { closePopup(); }
    });

    /* Gewichtete Zufallsziehung */
    function draw() {
      var total = cards.reduce(function (sum, c) { return sum + c.weight; }, 0);
      var roll = Math.random() * total;
      for (var i = 0; i < cards.length; i++) {
        roll -= cards[i].weight;
        if (roll <= 0) { return cards[i]; }
      }
      return cards[cards.length - 1];
    }

    var pack = qs('[data-booster-pack]', root);
    var cardEl = qs('[data-booster-card]', root);
    var result = qs('[data-booster-result]', root);
    var intro = qs('[data-booster-intro]', root);
    var hint = qs('[data-booster-hint]', root);
    var stage = qs('[data-booster-stage]', root);
    var gate = qs('[data-booster-gate]', root);

    /* Newsletter-Gate: erst anmelden, dann öffnen */
    var gateRequired = root.getAttribute('data-require-gate') === 'true' && gate;
    var subscribedKey = 'hoc_booster_sub_confirmed_v2';
    var confirmed = !!qs('[data-booster-confirmed]', root);
    function isSubscribed() {
      try { return confirmed || localStorage.getItem(subscribedKey) === '1'; } catch (e) { return confirmed; }
    }
    if (confirmed) {
      try { localStorage.setItem(subscribedKey, '1'); } catch (e) {}
    }
    function updateGateView() {
      var locked = gateRequired && !isSubscribed();
      if (gate) { gate.hidden = !locked; }
      if (stage) { stage.hidden = locked; }
    }
    updateGateView();

    function reveal(card) {
      /* Karte befüllen */
      cardEl.className = 'booster-card booster-card--' + (card.style || 'common') + (card.image ? ' booster-card--has-image' : '');
      var cardImg = qs('[data-booster-image]', cardEl);
      if (cardImg) { cardImg.src = card.image || root.getAttribute('data-logo'); }
      qs('[data-booster-rarity]', cardEl).textContent = card.rarity || '';
      qs('[data-booster-prize]', cardEl).textContent = card.prize || '';

      qs('[data-booster-result-title]', result).textContent = (card.rarity || '') + ' gezogen!';
      qs('[data-booster-result-text]', result).textContent = card.text || '';

      var codeBox = qs('[data-booster-code-box]', result);
      var applyBtn = qs('[data-booster-apply]', result);
      var applyStatus = qs('[data-booster-apply-status]', result);
      var discountCode = String(card.code || '').trim().toUpperCase();
      function showApplyStatus(message) {
        if (!applyStatus) return;
        applyStatus.textContent = message || '';
        applyStatus.hidden = !message;
      }
      showApplyStatus('');
      if (discountCode) {
        codeBox.hidden = false;
        qs('[data-booster-code]', result).textContent = discountCode;
        applyBtn.hidden = false;
        applyBtn.disabled = false;
        applyBtn.textContent = window.HOC.strings.boosterApply;
        applyBtn.onclick = function () {
          applyBtn.disabled = true;
          applyBtn.textContent = window.HOC.strings.boosterApplying;
          showApplyStatus('');
          mutateCart(function (currentCart) {
            var codes = (currentCart.discount_codes || []).map(function (discount) {
              return discount.code;
            }).filter(function (code) {
              return code && code.toUpperCase() !== discountCode;
            });
            codes.push(discountCode);
            return fetchJSON(cartEndpoint('update'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') })
            });
          }).then(function (cart) {
            rememberCart(cart);
            renderCartExtras(cart);
            var entry = (cart.discount_codes || []).find(function (discount) {
              return discount.code && discount.code.toUpperCase() === discountCode;
            });
            if (!entry) {
              applyBtn.textContent = window.HOC.strings.boosterRetry;
              applyBtn.disabled = false;
              showApplyStatus(window.HOC.strings.discountUnverified);
              return;
            }
            applyBtn.textContent = entry.applicable
              ? window.HOC.strings.boosterApplied : window.HOC.strings.boosterSaved;
            showApplyStatus(entry.applicable ? window.HOC.strings.boosterAppliedNote
              : cart.item_count === 0 ? window.HOC.strings.boosterSavedEmpty
              : window.HOC.strings.boosterSavedIneligible);
            if (drawerWrapper) refreshDrawer(false).catch(function () {});
          }).catch(function () {
            applyBtn.textContent = window.HOC.strings.boosterRetry;
            applyBtn.disabled = false;
            showApplyStatus(window.HOC.strings.boosterApplyError);
          });
        };
      } else {
        codeBox.hidden = true;
        applyBtn.hidden = true;
      }

      var sparkly = ['rare', 'illustration', 'special', 'ultra'].indexOf(card.style) > -1;
      root.classList.toggle('is-sparkly', sparkly);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('is-opening', 'is-revealed');
        result.hidden = false;
        if (intro) { intro.style.visibility = 'hidden'; }
        return;
      }
      root.classList.add('is-shaking');
      setTimeout(function () {
        root.classList.remove('is-shaking');
        root.classList.add('is-opening');
      }, 550);
      setTimeout(function () {
        root.classList.add('is-revealed');
      }, 1150);
      setTimeout(function () {
        result.hidden = false;
        if (intro) { intro.style.visibility = 'hidden'; }
      }, 1750);
    }

    function tryOpen() {
      if (gateRequired && !isSubscribed()) return;
      if (opened) { return; }
      opened = true;
      if (hint) { hint.style.visibility = 'hidden'; }
      if (!designMode) { storageSet(); }
      reveal(draw());
    }

    var isTouch = window.matchMedia('(pointer: coarse)').matches;
    if (isTouch && hint) {
      hint.textContent = root.getAttribute('data-hint-swipe') || hint.textContent;
    }

    if (pack) {
      var topEl = qs('.booster-pack__top', pack);
      if (!isTouch) {
        pack.addEventListener('click', tryOpen);
      } else {
        /* Tastatur/Screenreader lösen click mit detail 0 aus – bleibt zugänglich */
        pack.addEventListener('click', function (e) {
          if (e.detail === 0) { tryOpen(); }
        });

        /* Swipe von links nach rechts über die Abreißkante */
        var swipeStartX = null;
        var swipeStartY = null;
        var swiping = false;
        var SWIPE_THRESHOLD = 70;

        pack.addEventListener('touchstart', function (e) {
          if (opened) { return; }
          var t = e.touches[0];
          swipeStartX = t.clientX;
          swipeStartY = t.clientY;
          swiping = true;
          root.classList.add('is-dragging');
        }, { passive: true });

        pack.addEventListener('touchmove', function (e) {
          if (!swiping || opened) { return; }
          var t = e.touches[0];
          var dx = t.clientX - swipeStartX;
          var dy = t.clientY - swipeStartY;
          if (Math.abs(dy) > Math.abs(dx) * 1.4) { return; } /* vertikal = Scrollen */
          dx = Math.max(0, dx);
          if (topEl) {
            var shift = Math.min(dx, 130) * 0.9;
            topEl.style.transform = 'translateX(' + shift + 'px) rotate(' + Math.min(dx / 24, 6) + 'deg)';
            topEl.style.opacity = String(Math.max(0.35, 1 - dx / 220));
          }
          if (dx >= SWIPE_THRESHOLD) {
            swiping = false;
            root.classList.remove('is-dragging');
            if (topEl) { topEl.style.transform = ''; topEl.style.opacity = ''; }
            tryOpen();
          }
        }, { passive: true });

        var endSwipe = function () {
          if (!swiping) { return; }
          swiping = false;
          root.classList.remove('is-dragging');
          if (topEl) {
            topEl.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
            topEl.style.transform = '';
            topEl.style.opacity = '';
            setTimeout(function () { topEl.style.transition = ''; }, 260);
          }
        };
        pack.addEventListener('touchend', endSwipe);
        pack.addEventListener('touchcancel', endSwipe);
      }
    }

    document.addEventListener('keydown', function (event) {
      if (root.classList.contains('is-open')) containFocus(event, root);
    });

    /* Kopieren */
    var copyBtn = qs('[data-booster-copy]', root);
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = qs('[data-booster-code]', root).textContent;
        var done = function () {
          copyBtn.textContent = 'Kopiert ✓';
          setTimeout(function () { copyBtn.textContent = 'Kopieren'; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { copyBtn.textContent = window.HOC.strings.copyError; });
        } else { copyBtn.textContent = window.HOC.strings.copyError; }
      });
    }

    /* Anzeige-Logik: verzögert öffnen, Frequenz begrenzen */
    if (!designMode) {
      var last = storageGet();
      if (!last || Date.now() - last > reshowMs) {
        setTimeout(function () {
          var consent = qs('#shopify-pc__banner');
          if (!consent || consent.getClientRects().length === 0) openPopup();
        }, delayMs);
      }
    }

    /* Theme-Editor: Popup beim Auswählen der Section sofort zeigen */
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target && e.target.contains(root)) { openPopup(); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target && e.target.contains(root)) { closePopup(); }
    });
  });


  /* ---------- Barrierefreiheits-Widget ---------- */
  (function () {
    var widget = qs('[data-a11y]');
    if (!widget) { return; }
    var html = document.documentElement;
    var toggle = qs('[data-a11y-toggle]', widget);
    var panel = qs('#A11yPanel', widget);
    var storeKey = 'hoc_a11y';

    function load() {
      try { return JSON.parse(localStorage.getItem(storeKey) || '{}'); } catch (e) { return {}; }
    }
    function save(state) {
      try { localStorage.setItem(storeKey, JSON.stringify(state)); } catch (e) { /* Privatmodus */ }
    }
    var state = load();

    function apply() {
      html.classList.toggle('a11y-font-1', state.font === 1);
      html.classList.toggle('a11y-font-2', state.font === 2);
      ['contrast', 'motion', 'underline', 'legible'].forEach(function (opt) {
        html.classList.toggle('a11y-' + opt, !!state[opt]);
      });
      qsa('[data-a11y-font]', widget).forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(parseInt(btn.getAttribute('data-a11y-font'), 10) === (state.font || 0)));
      });
      qsa('[data-a11y-opt]', widget).forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(!!state[btn.getAttribute('data-a11y-opt')]));
      });
      save(state);
    }
    apply();

    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) {
      if (!widget.contains(e.target) && !panel.hidden) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });

    qsa('[data-a11y-font]', widget).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.font = parseInt(btn.getAttribute('data-a11y-font'), 10);
        apply();
      });
    });
    qsa('[data-a11y-opt]', widget).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opt = btn.getAttribute('data-a11y-opt');
        state[opt] = !state[opt];
        apply();
      });
    });
    var reset = qs('[data-a11y-reset]', widget);
    if (reset) {
      reset.addEventListener('click', function () {
        state = {};
        apply();
      });
    }
  })();

  /* ---------- Back-to-Top ---------- */
  (function () {
    var btn = qs('[data-back-top]');
    if (!btn) { return; }
    var onScroll = function () {
      btn.hidden = window.scrollY < 600;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: document.documentElement.classList.contains('a11y-motion') ? 'auto' : 'smooth' });
    });
  })();

})();
